import { z } from "zod";

const PathnameSchema = z
  .string()
  .min(1)
  .transform((pathname) => (pathname.startsWith("/") ? pathname : `/${pathname}`))
  .brand("Pathname");

export type Pathname = z.infer<typeof PathnameSchema>;

export const Pathname = {
  isRoot: (pathname: Pathname) => pathname === "/",
  root: () => "/" as Pathname,
  schema: PathnameSchema,
};
